import { Injectable, signal } from "@angular/core";
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";
import { IBucketItemInfo } from "../bucket-items/models/bucket-item-info.model";
import { BucketList } from "../buckets/models/bucket.model";

@Injectable({
  providedIn: 'root',
})
export class BucketDataService {
  private readonly _itemData = signal<Partial<IBucketItemInfo> | null>(null);
  private readonly _bucketData = signal<Partial<BucketList>[] | null>(null);

  readonly selectedItem$ = toObservable(this._itemData).pipe(
    filter((v): v is Partial<IBucketItemInfo> => v !== null)
  );
  readonly bucketDataObs = toObservable(this._bucketData).pipe(
    filter((v): v is Partial<BucketList>[] => v !== null)
  );

  public setBucketItemData(data: Partial<IBucketItemInfo>) {
    this._itemData.set(data);
  }

  public setBucketData(data: Partial<BucketList>[]) {
    this._bucketData.set(data);
  }

  public getBucketData(): Observable<Partial<BucketList>[]> {
    return this.bucketDataObs;
  }
}
